import guid from "@ciaopeople/cp-shatsu/Utils";
import { GenericQSStatsCollector } from "./GenericQSStatsCollector.js";
import { MediaId } from "../../../model/MediaInfo.js";
import { MapperConfigFlags } from "../mappers/CommonEventMapper.js";
import { CP_EmbedType } from "../../ads/adcall/CustomParams.js";
import { CPProductName } from "../../../config/CPProducts.js";



interface CData {
    
    id: string, // collector-id
    v: string, // player version
    src: "web", //source context
    l: string, //label
    ts: number, // timestamp
    vid: MediaId,
    eu: string, //embed url
    rf?: string, //referral

}

export interface YMStatsMapperConfig extends MapperConfigFlags {
    embedType: CP_EmbedType,
    product: CPProductName,
    ymHostname: string,
    playerName: string
};



/**
 * Collector for YMStats events, extending `GenericQSStatsCollector`.
 * 
 * This class is responsible for collecting and sending statistics events related to media playback.
 * It generates a unique collector ID for each instance and provides a method to collect events with
 * relevant metadata such as video ID, label, player version, and environment information.
 *
 * @remarks
 * - The collector uses the browser's `window` object to gather environment data.
 * - Events are sent using the `collect` method inherited from `GenericQSStatsCollector`.
 *
 * @example
 * ```typescript
 * const collector = new YMStatsCollector(window, "https://stats.example.com");
 * collector.collectEvent("video123", "play");
 * ```
 *
 * @public
 */
export class YMStatsCollector extends GenericQSStatsCollector{

    private collectorId: string;
    constructor(private window: Window, baseUrl: string) {
        super("YMStats",baseUrl);
        this.collectorId = guid();
    }




    public collectEvent(videoId: MediaId, label: string,  playerVersion: string = "parthenope"): Promise<void> {
        
        
        if(videoId && videoId != "" && label && label != "") {          
            const data: CData = {
                id: this.collectorId,
                v: playerVersion,
                src: "web",
                l: label,
                ts: new Date().getTime(),
                vid: videoId,
                eu: this.window.location.href.toString(),
            };
            if(document.referrer) data.rf = document.referrer.toString();
            return this.collect("GET", data);
        }
        else return Promise.reject("Missing label and/or videoid");

    }
 

}